import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import api from '../../../service/api';
import CONSTANT from '../../../Constant/Constant';
import ProfileIcon from '../../shared/ProfileIcon';
import LillySources from '../../../config/ProfileDetailsData.json';
import {Chip } from '@mui/material';
import vendorInfo from '../../../config/MergeSourceScope.json';

export default function Asynchronous(props) {
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const [loading, setLoading] = React.useState(open);
    const [value, setValue] = React.useState('');
    const [optionValue, setoptionValue] = React.useState(null);
    let flag = (value === null) || (value !== null && value !== undefined && value.length === 0);
    flag = (props.error && flag)
    const [lengthFlag, setFlag] = React.useState(flag);
    const [interval, setIntervals] = React.useState();
    const [isVendorOnlyHCO] = React.useState(props.hcoQuery?.onlyIqviaHCOInRelation)
    const [sourceData] = React.useState(vendorInfo.vendorChipData)
    /**
     * Handle change in Text
     * @param {*} event 
     */
    const handelText = (event) => {
        if (event.target.value.length >= 1) {
            if (interval !== undefined) {
                clearTimeout(interval);
            }
            callOptions(event.target.value);
        }
        setValue(event.target.value)
    }

     /**
     * checks the sources weather they are lilly or vender managed
     * @param {*} sources :List of Sources
     * @returns :one source value
     */
     const checkSource = (sources) => {
        let lillySource = [];
        if ((sources === undefined) || (Object.keys(sources).length === 0)) {                     
            return sources;
        } else if (typeof(sources) == 'string'){
            if(CONSTANT.ALL_SOURCES.includes(sources)){
                return CONSTANT.LILLY_SOURCES_VALUES[sources]
            }
        } else {       
            sources.forEach((source) => {                
                if (CONSTANT.ALL_SOURCES.includes(source.value)) {                                   
                    lillySource.push(source.value);                    
                }                
            })
        }        
        if (lillySource.length === 0) {     
            return sources;
        }else if(lillySource.length == 1){           
                return [{ value: CONSTANT.LILLY_SOURCES_VALUES[lillySource[0]] }]
            } else{                          
                if(lillySource.every((res)=>  CONSTANT.LILLY_SOURCES_FOR_EDIT_PROFILE.includes(res))){
                    return [{value: CONSTANT.LILLY_SOURCES_VALUES['MNGD-AFF']}]
                } else if(lillySource.every((res)=>  CONSTANT.VENDOR_SOURCE.includes(res) )){                
                    return null
                } else if (lillySource.includes(CONSTANT.VENDOR_SOURCE[0])) {
                    return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.VENDOR_SOURCE[0]]}]
                } else if (lillySource.includes(CONSTANT.LILLY_SOURCES[0])) {
                    return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.LILLY_SOURCES[0]] }]
                } else if (lillySource.includes(CONSTANT.LILLY_SOURCES[1])) {
                    return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.LILLY_SOURCES[1]] }]
                } else if (lillySource.includes(CONSTANT.LILLY_SOURCES[2])) {
                    return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.LILLY_SOURCES[2]] }]
                } else if (lillySource.includes(CONSTANT.LILLY_SOURCES[3])) {
                    return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.LILLY_SOURCES[3]] }]
                }
            }
    }

    // source data to display below profile data
    
    /**
     * Identify the Source name to display below profile data
     * @param {*} source 
     */
    const sourceChipData = (source) =>{

        if (source?.some((e) => vendorInfo.defaultVendorValue.some((arr) => e.value == arr))) {
            let vendor = source?.find((e) => vendorInfo.defaultVendorValue.some((arr) => e.value == arr))
            return (sourceData[vendor.value])

        }
        else if (source?.length > 1) {
            var sourceValue
            for (const element of source){
                sourceValue = sourceData[element.value]
                 if (sourceValue !== undefined) {
                    break;
                }
            }
            return (sourceValue === undefined ? source[0].value : sourceValue);
        }
        else {
            return (sourceData[source[0]?.value] == undefined ? (source[0]?.value) : (sourceData[source[0]?.value]))

        }

    }

    /**
     * Add Relation 
     * @param {*} newValue 
     */
    const addRelation = (newValue) => {
        setoptionValue(newValue);
        if (newValue !== null) {
            let checkingSourceForHco = {...newValue._source,['Source'] : checkSource(newValue._source['Source']) }
            props.addRelation({...newValue, _source: checkingSourceForHco}, false);
            setFlag(newValue === null);
        } else {
            setFlag(true);
            props.addRelation({ _source: '' }, true);
        }

    }

    //  // source data to display below profile data
    // const sourceChipData = (source) =>{

    //     if (source?.some((e) => vendorInfo.defaultVendorValue.some((arr) => e.value == arr))) {
    //         let vendor = source?.find((e) => vendorInfo.defaultVendorValue.some((arr) => e.value == arr))
    //         return (sourceData[vendor.value])

    //     }
    //     else if (source?.length > 1) {
    //         var sourceValue
    //         for (const element of source){
    //             sourceValue = sourceData[element.value]
    //              if (sourceValue !== undefined) {
    //                 break;
    //             }
    //         }
    //         return (sourceValue === undefined ? source[0].value : sourceValue);
    //     }
    //     else {
    //         return (sourceData[source[0]?.value] == undefined ? (source[0]?.value) : (sourceData[source[0]?.value]))

    //     }

    // }
    const removeDuplicateSource = (value, source) =>{
        const firstIndex = value.indexOf(source)        
        const lastIndex = value.lastIndexOf(source);   
        if (lastIndex !== -1 && firstIndex != lastIndex) {
            return value.slice(0, lastIndex - 1) + value.slice(lastIndex + source.length);
        }
        return value;
    }

    /**
     * Type-head logic 
     * @param {*} term 
     */
    const callOptions = async (term) => {
        let active = true;
        setLoading(true);
        let intervalId = setTimeout(
            () => {
                (async () => {
                    let countries = [];
                    term.length !== 0 &&
                      (await api
                        .getAdvanceSearch(
                          "HCO",
                          props?.empQuery ? props.empQuery :
                        isVendorOnlyHCO && (LillySources.VENDOR_MANAGED_SOURCES.includes(props.source) || LillySources.OPEN_DATA_SOURCES.includes(props.source)) ? 
                            `equals(ActiveFlag,["Y"]) and not(equals(ClassificationCode, [\"Buying Group\"])) and equals(Source,["${props.source}"])` : 
                          props.searchHCOPayload &&
                            !props.iqviaEnnable &&
                            props.searchHCOPayload.cross_source_enable
                            ? `${props.hcoQuery.hco_search_query} ,\"${props.searchHCOPayload.vendor_name}\"])`
                            : (LillySources.LILLY_MANAGED_SOURCES.includes(
                                props.source
                              ))
                            ? removeDuplicateSource(`${props.hcoQuery.hco_search_query},\"${props.source}\"])`, `\"${props.source}\"`)
                            : `equals(ActiveFlag,["Y"]) and not(equals(ClassificationCode, [\"Buying Group\"])) and equals(Source,["${props.source}"])`,
                            
                          "",
                          [props.country],
                          term,
                          true,
                          CONSTANT.TYPE_AHEAD_NUMBER_HCO
                        )
                        .then((res) => {
                            props.isVendor ?
                                countries = [
                                    ...JSON.parse(JSON.stringify(res.data.result)),
                                ] : 
                                    props?.addOnlyExistingRelation ?
                                    countries = [
                                        ...JSON.parse(JSON.stringify(res.data.result)),
                                    ] :
                                        countries = [
                                            {
                                                _id: "12",
                                                _source: {
                                                    secondaryLabel: "Add New HCO [ ",
                                                    label: term,
                                                    link: " ]",
                                                },
                                            },
                                            ...JSON.parse(JSON.stringify(res.data.result)),
                                        ];

                                if(res.data.result.length === 0){props.setShowVendorText(true)}
                                else{props.setShowVendorText(false)}
                          if (active) {
                            setOptions(countries);
                            setLoading(false);
                          }
                        }));
                })();

            }, 1000);
        setIntervals(intervalId);
    };

    React.useEffect(() => {
        if (props.clear) {
            setValue('');
            setoptionValue(null)
        }
    }, [props.clear])

    return (
        <Autocomplete
            value={optionValue}
            id="asynchronous-demo"
            className=' mt-0'
            open={open}
            
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            renderOption={(props, option, selected) => (
               
                <React.Fragment key={option._id}>
                    {option._source.link !== undefined && <span className='text-primary' {...props}>{option._source.secondaryLabel}{option._source.label}{option._source.link}</span>}
                    {
                        option._source.link === undefined &&
                        <React.Fragment key={option._id}>
                            <div className="ms-2" {...props}>
                                <ProfileIcon
                                    type={'HCO'}
                                    sx={{marginRight: '15px', height:'40px', width:'40px'}}
                                />
                            <span>{option._source.label}, <span className='text-muted'>{option._source.secondaryLabel}</span> </span>
                                                   
                               {option?._source?.Source != undefined && option?._source?.Source.length != 0 ? <Chip className="ml-3 mr-5" variant="outlined" size="small"  color={sourceChipData(option._source.Source) === "Lilly Managed" ? 'error':'primary'} style={{ marginLeft: "auto" }} label={sourceChipData(option._source.Source)} /> : ''}

                            </div>
                        </React.Fragment>
                    }
                </React.Fragment>
            )
            }
            filterOptions={(options, state) => options}
            onChange={(event, value) => addRelation(value)}
            isOptionEqualToValue={(option, value) =>
            (option?._source?.label === value?._source?.label
                && option?._source?.secondaryLabel === value?._source?.secondaryLabel)}
            getOptionLabel={(option) => ((option?._source?.label)? option?._source?.label:'')}
            options={options}
            loading={loading}
            renderInput={(params) => (
                <TextField
                    value={value}
                    {...params}
                    onChange={handelText}
                    variant="standard"     
                    error={lengthFlag || flag}
                    helperText={(lengthFlag || flag) ?  <span id="SpanIdTxt">Please add relation !</span> : " "}
                
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}